module.exports = __webpack_public_path__ + "static/media/5en.27cbecae.jpg";